import {
  Tooltip,
  TooltipContent,
  TooltipTrigger
} from "@/components/ui/tooltip";
import { cn } from "@/utils/utils";
import { ReactNode } from "react";

interface Props {
  children: ReactNode;
  tooltip?: string | JSX.Element;
  className?: string;
}

const DetailIconWrapper: React.FC<Props> = ({
  children,
  tooltip,
  className
}) => {
  const detailIcon = (
    <div
      className={cn(
        "flex gap-1 border-[0.5px] border-transparent py-1 px-[6px] items-center transition-colors duration-200 ease-in-out rounded-md",
        tooltip && "hover:bg-surface-hover-soft hover:border-border-border2",
        className
      )}
    >
      {children}
    </div>
  );
  return tooltip ? (
    <Tooltip>
      <TooltipTrigger asChild>{detailIcon}</TooltipTrigger>
      <TooltipContent>{tooltip}</TooltipContent>
    </Tooltip>
  ) : (
    detailIcon
  );
};

export default DetailIconWrapper;
